import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import store from 'store2';

@Component({
  selector: 'app-medicines',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './medicines.component.html',
  styleUrls: ['./medicines.component.css']
})
export class MedicinesComponent implements OnInit {
  pharmacyAppUrl: SafeResourceUrl;
  @ViewChild('pharmacyIframe') iframe?: ElementRef<HTMLIFrameElement>;
  private readonly pharmacyUrl = environment.pharmacyAppUrl;
  private readonly messageHandler = (event: MessageEvent) => this.handleIframeMessage(event);

  constructor(private sanitizer: DomSanitizer) {
    // PharmacyFront app URL from environment
    this.pharmacyAppUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pharmacyUrl);
  }

  ngOnInit() {
    // Listen for messages from the iframe
    window.addEventListener('message', this.messageHandler);
  }

  ngAfterViewInit() {
    // Wait for iframe to load, then send the token
    const iframe = this.iframe?.nativeElement;
    if (iframe) {
      iframe.addEventListener('load', this.iframeLoadHandler);
    }
  }

  private iframeLoadHandler = () => {
    this.sendTokenToIframe();
  };

  private sendTokenToIframe() {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const role = store('role');

    if (token && this.iframe?.nativeElement.contentWindow) {
      this.iframe.nativeElement.contentWindow.postMessage(
        {
          type: 'AUTH_TOKEN',
          token: token,
          role: role
        },
        this.pharmacyUrl
      );
    }
  }

  private handleIframeMessage(event: MessageEvent) {
    // Only accept messages from PharmacyFront
    if (event.origin !== this.pharmacyUrl) {
      return;
    }

    // Handle different message types from PharmacyFront
    switch (event.data.type) {
      case 'TOKEN_REQUEST':
        // PharmacyFront is requesting the token
        this.sendTokenToIframe();
        break;
      case 'LOGOUT':
        // PharmacyFront detected invalid token, logout from UAT
        this.handleLogout();
        break;
    }
  }

  private handleLogout() {
    // Clear UAT session and redirect to login
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    window.location.href = '/login';
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageHandler);
    const iframe = this.iframe?.nativeElement;
    if (iframe) {
      iframe.removeEventListener('load', this.iframeLoadHandler);
    }
  }
}
